var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper } from '@dixa/lib-shared-habla';
import uniqueId from 'lodash/uniqueId';
import { useState } from 'react';
import { InputTemplate } from 'components/inputTemplate';
/**
 * A component that is a custom implementation of the AceEditor.
 *
 * It wraps the input template component with the field wrapper component from
 * habla to add labels and redux-form support. The actual AceEditor
 * implementation is inside the input template component. Input template also
 * wraps the AceEditor furthermore with input wrapper from habla which adds all
 * validation and input states automatically. The implementation was split into
 * two components to be able to easily change the outer field wrapper in case we
 * want to use something else than redux-form.
 */
export const FieldTemplate = (_a) => {
    var { className, input, label, meta, required, disabled, helpIcon, description, noLabel, noAlert, labelFor } = _a, inputTemplateProps = __rest(_a, ["className", "input", "label", "meta", "required", "disabled", "helpIcon", "description", "noLabel", "noAlert", "labelFor"]);
    const [fieldTemplateId] = useState(() => labelFor || uniqueId('fieldTemplate-'));
    return (_jsx(FieldWrapper, Object.assign({ className: className, label: label, labelFor: fieldTemplateId, meta: meta, required: required, helpIcon: helpIcon, description: description, noLabel: noLabel, noAlert: noAlert, disabled: disabled }, { children: _jsx(InputTemplate, Object.assign({ status: FieldWrapper.getStatus(meta), fieldTemplateId: fieldTemplateId, disabled: disabled }, input, inputTemplateProps)) })));
};
